'use client'
import Image from 'next/image'
import LinkComponent from '@components/LinkComponent'

// ─── Social icons ─────────────────────────────────────────────────────────────

const SOCIAL_ICONS = {
  phone:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 5.55 5.55l.96-.96a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  email:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>,
  line:      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/></svg>,
  whatsapp:  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>,
  wechat:    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.295.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c-.166-.547-.253-1.12-.253-1.707 0-3.886 3.529-7.032 7.88-7.032.149 0 .295.006.441.013C15.584 4.525 12.458 2.188 8.691 2.188zm-1.909 3.5a.954.954 0 1 1 0 1.909.954.954 0 0 1 0-1.909zm4.773 0a.954.954 0 1 1 0 1.909.954.954 0 0 1 0-1.909zM15.319 9.75c-3.527 0-6.39 2.54-6.39 5.676 0 3.137 2.863 5.676 6.39 5.676.679 0 1.332-.097 1.948-.271a.594.594 0 0 1 .49.064l1.475.864a.243.243 0 0 0 .127.041.224.224 0 0 0 .224-.224.38.38 0 0 0-.037-.162l-.302-1.148a.45.45 0 0 1 .163-.509C20.765 18.75 21.71 17.31 21.71 15.426c0-3.136-2.864-5.676-6.391-5.676zm-1.909 3.182a.727.727 0 1 1 0 1.455.727.727 0 0 1 0-1.455zm3.818 0a.727.727 0 1 1 0 1.455.727.727 0 0 1 0-1.455z"/></svg>,
  facebook:  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>,
  instagram: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>,
  youtube:   <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  linkedin:  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  tiktok:    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/></svg>,
  telegram:  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M23.91 3.79 20.3 20.84c-.25 1.21-.98 1.5-2 .94l-5.5-4.07-2.66 2.57c-.3.3-.55.55-1.1.55l.4-5.56 10.1-9.14c.44-.39-.1-.6-.68-.22L6.14 13.4l-5.44-1.7c-1.18-.37-1.2-1.18.26-1.75L22.4 2.1c.98-.36 1.85.24 1.51 1.69z"/></svg>,
  viber:     <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12.4 2C7.8 2 3.7 2.7 3.6 8.3c-.04 2.5-.1 5.7.98 8.2.13.3.06.64-.2.85l-2.07 1.7a.6.6 0 0 0-.1.85l1.6 2c.2.25.55.32.83.16l2.6-1.5a.8.8 0 0 1 .7-.03c1.5.6 3.2.9 4.96.9 4.6 0 8.7-.7 8.8-6.3.1-5.9-.7-11.5-8.3-13.1a.3.3 0 0 0-.06 0zm.17 2.05c6.3 1.35 6.9 6.05 6.8 10.7-.06 4.15-3.2 4.6-6.9 4.6-1.5 0-3-.24-4.3-.72a.9.9 0 0 0-.5-.02l-1.9.44 1.1-1.55a.8.8 0 0 0-.06-.98c-1.14-1.35-1.34-3.75-1.3-6.55.08-4.4 2.35-5.66 7.06-5.92zm-.03 2.2c-.35 0-.63.28-.63.62 0 .35.28.63.63.63 2 0 3.65 1.65 3.65 3.66 0 .35.28.63.62.63.35 0 .63-.28.63-.63 0-2.7-2.2-4.9-4.9-4.9zm-.24 1.9c-.32.05-.55.35-.5.68l.03.15c.05.32.35.55.68.5.7-.1 1.34.4 1.44 1.1.05.33.35.55.68.5.32-.05.55-.35.5-.68-.16-1.12-1.16-1.9-2.28-1.75l-.27.04a.6.6 0 0 0-.28.46zM8.2 10.3c-.5-.02-.94.31-1.02.8-.14.85.24 1.9.9 2.94.85 1.3 2.06 2.32 3.5 2.9.47.2 1 .08 1.35-.28l.55-.58a.63.63 0 0 0-.03-.9l-1-.9a.63.63 0 0 0-.83-.02l-.3.24a5.9 5.9 0 0 1-2.1-2.1l.24-.3a.63.63 0 0 0-.02-.83l-.9-1a.63.63 0 0 0-.34-.17z"/></svg>,
}

const SOCIAL_COLORS = {
  phone: '#22c55e', email: '#6b7280', line: '#00b900', whatsapp: '#25d366',
  wechat: '#07c160', facebook: '#1877f2', instagram: '#e1306c',
  youtube: '#ff0000', linkedin: '#0077b5', tiktok: '#010101',
  telegram: '#26a5e4', viber: '#7360f2',
}

// href builders per channel
function buildHref(key, value) {
  if (!value) return null
  if (key === 'phone')     return value.startsWith('tel:') ? value : `tel:${value}`
  if (key === 'email')     return `mailto:${value}`
  if (key === 'whatsapp')  return `https://wa.me/${value.replace(/\D/g, '')}`
  if (key === 'line')      return `https://line.me/R/ti/p/${value.replace('@','')}`
  if (key === 'telegram')  return `https://t.me/${value.replace('@','')}`
  if (key === 'viber')     return `viber://chat?number=${encodeURIComponent(value.replace(/\s/g, ''))}`
  if (key === 'wechat')    return null // wechat has no universal deep link — show anyway
  return value // facebook, instagram, etc — assumed full URL
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

const rc = (val, fb = '#374151') => val || fb

const DEFAULT_FIELDS = [
  { id: 'name',     enabled: true,  align: 'center', fontSize: 1.0,    fontWeight: '700', color: 'var(--color-main)',      bg: 'transparent', lineClamp: 2, fixedHeight: false },
  { id: 'position', enabled: true,  align: 'center', fontSize: 0.8125, fontWeight: '500', color: 'var(--color-secondary)', variant: 'none', badgeColor: 'var(--thirdcolor)', badgeTextColor: '#ffffff', radius: 20 },
  { id: 'contacts', enabled: true,  align: 'center', layout: 'icon-row', iconSize: 32, iconRadius: 8,  iconStyle: 'filled', color: 'var(--iconcolor)', showLabels: false, visibleContacts: ['phone','email','line','whatsapp'] },
  { id: 'socials',  enabled: false, align: 'center', layout: 'icon-row', iconSize: 28, iconRadius: 20, iconStyle: 'subtle', color: 'var(--color-secondary)', useBrandColors: true, visibleSocials: ['facebook','instagram','youtube','linkedin','tiktok'] },
  { id: 'profileBtn', enabled: false, align: 'center', text: { en: 'View Profile', th: '', cn: '', ru: '', de: '', it: '', fr: '' }, variant: 'filled', color: 'var(--color-main)', textColor: '#ffffff', fontSize: 0.875, fontWeight: '600', radius: 8, fullWidth: true, paddingY: 8 },
]

const DEFAULT_CARD = {
  bg: '#ffffff', radius: 16, borderWidth: 0, borderColor: '#e5e7eb',
  shadow: '0 4px 24px rgba(0,0,0,0.10)',
  imageShape: 'circle', imageWidth: 96, imageAspectRatio: '1:1', imageHeight: 96,
  imagePosition: 'top-center',
  imageBorderWidth: 3, imageBorderColor: 'var(--color-main)',
  headerBg: 'transparent', contentPadding: 16,
}

const ASPECT_RATIOS = {
  '1:1': 1, '4:5': 4 / 5, '3:4': 3 / 4, '4:3': 4 / 3, '16:9': 16 / 9,
}

// Mirrors the editor's resolveImageDims() so the live card matches the preview,
// including legacy configs saved with the old single `imageSize` field. All shapes
// (including circle, which becomes an oval when non-square) respect the ratio.
function resolveImageDims(card) {
  const width = card.imageWidth ?? card.imageSize ?? 96
  const ratioKey = card.imageAspectRatio ?? '1:1'
  if (ratioKey === 'free') return { width, height: card.imageHeight ?? width }
  const ratio = ASPECT_RATIOS[ratioKey] ?? 1
  return { width, height: Math.round(width / ratio) }
}

// ─── Icon button ──────────────────────────────────────────────────────────────

function IconBtn({ iconKey, href, size, radius, iconStyle, baseColor, useBrand, showLabel }) {
  const color = useBrand ? (SOCIAL_COLORS[iconKey] ?? baseColor) : baseColor
  let bg, tc, border
  if (iconStyle === 'filled')   { bg = color;        tc = '#fff'; border = 'none' }
  if (iconStyle === 'outlined') { bg = 'transparent'; tc = color;  border = `1.5px solid ${color}` }
  if (iconStyle === 'subtle')   { bg = `${color}18`; tc = color;  border = `1px solid ${color}25` }

  const btn = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
      <div style={{ width: size, height: size, borderRadius: radius, background: bg, border, display: 'flex', alignItems: 'center', justifyContent: 'center', color: tc, flexShrink: 0, cursor: href ? 'pointer' : 'default' }}>
        {SOCIAL_ICONS[iconKey]}
      </div>
      {showLabel && <span style={{ fontSize: '0.6rem', color: rc(baseColor, '#9ca3af'), textTransform: 'capitalize' }}>{iconKey}</span>}
    </div>
  )

  if (!href) return btn
  return <a href={href} target={['phone','email'].includes(iconKey) ? undefined : '_blank'} rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{btn}</a>
}

// ─── AgentCard ────────────────────────────────────────────────────────────────

const AgentCard = ({ agent, cardStyle, dictionary, lang }) => {
  const cfg    = cardStyle ?? {}
  const card   = cfg.card   ?? DEFAULT_CARD
  const fields = (cfg.fields?.length > 0) ? cfg.fields : DEFAULT_FIELDS

  const { width: imgW, height: imgH } = resolveImageDims(card)
  const imgShape   = card.imageShape       ?? 'circle'
  const imgRadius  = imgShape === 'circle' ? '50%' : imgShape === 'rounded' ? 12 : 0
  const imgPos     = card.imagePosition    ?? 'top-center'
  const isSide     = imgPos === 'left' || imgPos === 'right'
  const borderCol  = rc(card.imageBorderColor, '#019da4')
  const padding    = card.contentPadding   ?? 16

  // ── Photo ──────────────────────────────────────────────────────────────
  // Two-layer: outer handles border + shape, inner clips the image.
  // Prevents Next.js fill Image from bleeding outside border-radius.
  const borderW = card.imageBorderWidth ?? 3
  const photo = (
    <div style={{
      width: imgW, height: imgH,
      borderRadius: imgRadius,
      border: borderW > 0 ? `${borderW}px solid ${borderCol}` : 'none',
      flexShrink: 0, boxSizing: 'border-box',
    }}>
      <div style={{
        width: '100%', height: '100%',
        borderRadius: imgRadius,
        overflow: 'hidden',
        position: 'relative',
        background: '#e5e7eb',
      }}>
        {agent.cover ? (
          <Image src={agent.cover} fill sizes={`${Math.max(imgW, imgH)}px`} style={{ objectFit: 'cover' }} alt={agent.agentName ?? ''} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: borderCol + '22', fontSize: Math.min(imgW, imgH) * 0.35, fontWeight: 700, color: borderCol }}>
            {(agent.agentName ?? '?').charAt(0).toUpperCase()}
          </div>
        )}
      </div>
    </div>
  )

  // ── Field renderer ─────────────────────────────────────────────────────
  const renderField = (field) => {
    if (!field.enabled) return null

    if (field.isDivider) return (
      <div key={field.id} style={{ marginTop: field.marginTop ?? 6, marginBottom: field.marginBottom ?? 6, borderTop: `${field.thickness ?? 1}px ${field.style ?? 'solid'} ${rc(field.color, '#e5e7eb')}` }} />
    )

    // Name
    if (field.id === 'name') {
      if (!agent.agentName) return null
      const clamp  = field.lineClamp ?? 2
      const lineH  = 1.3
      const height = field.fixedHeight ? `${clamp * lineH * (field.fontSize ?? 1)}rem` : undefined
      return (
        <div key="name" style={{ textAlign: field.align, height, overflow: 'hidden', background: field.bg && field.bg !== 'transparent' ? rc(field.bg) : undefined }}>
          <span style={{ display: '-webkit-box', WebkitLineClamp: clamp, WebkitBoxOrient: 'vertical', overflow: 'hidden', fontSize: `${field.fontSize ?? 1}rem`, fontWeight: field.fontWeight ?? '700', color: rc(field.color, '#111827'), lineHeight: lineH }}>
            {agent.agentName}
          </span>
        </div>
      )
    }

    // Position
    if (field.id === 'position') {
      if (!agent.position) return null
      if (field.variant === 'badge') {
        const color = rc(field.badgeColor, '#228be6')
        const tc    = rc(field.badgeTextColor, '#fff')
        return (
          <div key="position" style={{ display: 'flex', justifyContent: field.align === 'center' ? 'center' : field.align === 'right' ? 'flex-end' : 'flex-start' }}>
            <span style={{ display: 'inline-flex', background: color, color: tc, fontSize: `${field.fontSize ?? 0.8125}rem`, fontWeight: field.fontWeight ?? '500', padding: '3px 10px', borderRadius: field.radius ?? 20, lineHeight: 1.4 }}>
              {agent.position}
            </span>
          </div>
        )
      }
      return (
        <div key="position" style={{ textAlign: field.align }}>
          <span style={{ fontSize: `${field.fontSize ?? 0.8125}rem`, fontWeight: field.fontWeight ?? '500', color: rc(field.color, '#6b7280') }}>
            {agent.position}
          </span>
        </div>
      )
    }

    // Contacts
    if (field.id === 'contacts') {
      const keys       = (field.visibleContacts ?? ['phone','email','line','whatsapp']).filter(k => agent[k])
      if (!keys.length) return null
      const size       = field.iconSize    ?? 32
      const radius     = field.iconRadius  ?? 8
      const iconStyle  = field.iconStyle   ?? 'filled'
      const baseColor  = rc(field.color, '#019da4')
      const showLabels = field.showLabels  ?? false
      const layout     = field.layout      ?? 'icon-row'
      const justify    = field.align === 'center' ? 'center' : field.align === 'right' ? 'flex-end' : 'flex-start'

      const rawFor = (key) => ({
        phone: agent.phone, email: agent.email, line: agent.line, whatsapp: agent.whatsapp,
        wechat: agent.wechat, telegram: agent.telegram, viber: agent.viber,
      }[key] ?? null)

      const items = keys.map(key => {
        const href = buildHref(key, rawFor(key))
        return <IconBtn key={key} iconKey={key} href={href} size={size} radius={radius} iconStyle={iconStyle} baseColor={baseColor} useBrand={false} showLabel={showLabels} />
      })

      if (layout === 'icon-grid') return <div key="contacts" style={{ display: 'grid', gridTemplateColumns: `repeat(4, ${size}px)`, gap: 6, justifyContent: justify }}>{items}</div>
      if (layout === 'text-list') return (
        <div key="contacts" style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: justify === 'center' ? 'center' : justify === 'flex-end' ? 'flex-end' : 'flex-start' }}>
          {keys.map(key => {
            const raw  = rawFor(key)
            const href = buildHref(key, raw)
            const color = SOCIAL_COLORS[key] ?? baseColor
            const label = raw?.replace('tel:','') ?? raw
            const el = (
              <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ color, display: 'flex' }}>{SOCIAL_ICONS[key]}</span>
                <span style={{ fontSize: `${field.fontSize ?? 0.8125}rem`, color: rc(field.color, '#374151') }}>{label}</span>
              </div>
            )
            return href ? <a key={key} href={href} target={['phone','email'].includes(key) ? undefined : '_blank'} rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{el}</a> : el
          })}
        </div>
      )
      // icon-row default
      return <div key="contacts" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: justify }}>{items}</div>
    }

    // Socials
    if (field.id === 'socials') {
      const keys      = (field.visibleSocials ?? ['facebook','instagram','youtube','linkedin','tiktok']).filter(k => agent[k])
      if (!keys.length) return null
      const size      = field.iconSize    ?? 28
      const radius    = field.iconRadius  ?? 20
      const iconStyle = field.iconStyle   ?? 'subtle'
      const baseColor = rc(field.color, '#6b7280')
      const useBrand  = field.useBrandColors ?? true
      const showLabels = field.showLabels ?? false
      const layout    = field.layout      ?? 'icon-row'
      const justify   = field.align === 'center' ? 'center' : field.align === 'right' ? 'flex-end' : 'flex-start'

      const items = keys.map(key => (
        <IconBtn key={key} iconKey={key} href={agent[key]} size={size} radius={radius} iconStyle={iconStyle} baseColor={baseColor} useBrand={useBrand} showLabel={showLabels} />
      ))

      if (layout === 'icon-grid') return <div key="socials" style={{ display: 'grid', gridTemplateColumns: `repeat(4, ${size}px)`, gap: 6, justifyContent: justify }}>{items}</div>
      if (layout === 'text-list') return (
        <div key="socials" style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: justify === 'center' ? 'center' : justify === 'flex-end' ? 'flex-end' : 'flex-start' }}>
          {keys.map(key => (
            <a key={key} href={agent[key]} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ color: useBrand ? (SOCIAL_COLORS[key] ?? baseColor) : baseColor, display: 'flex' }}>{SOCIAL_ICONS[key]}</span>
              <span style={{ fontSize: `${field.fontSize ?? 0.8125}rem`, color: rc(field.color, '#374151'), textTransform: 'capitalize' }}>{key}</span>
            </a>
          ))}
        </div>
      )
      return <div key="socials" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: justify }}>{items}</div>
    }

    // Profile button → links to /agents/:slug
    if (field.id === 'profileBtn') {
      if (!agent.slug) return null
      const v        = field.variant ?? 'filled'
      const color    = rc(field.color, '#019da4')
      const tc       = rc(field.textColor, '#fff')
      let bg, border, btnColor
      if (v === 'filled')   { bg = color;        btnColor = tc;    border = 'none' }
      if (v === 'outlined') { bg = 'transparent'; btnColor = color; border = `1.5px solid ${color}` }
      if (v === 'subtle')   { bg = `${color}18`; btnColor = color; border = `1px solid ${color}25` }
      const justify  = field.align === 'center' ? 'center' : field.align === 'right' ? 'flex-end' : 'flex-start'
      const btnText  = typeof field.text === 'object' ? (field.text?.[lang] || field.text?.en || 'View Profile') : (field.text || 'View Profile')
      return (
        <div key="profileBtn" style={{ display: 'flex', justifyContent: justify, marginTop: 4 }}>
          <LinkComponent
            href={`/agents/${agent.slug}`}
            style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              background: bg, color: btnColor, border,
              fontSize: `${field.fontSize ?? 0.875}rem`, fontWeight: field.fontWeight ?? '600',
              padding: `${field.paddingY ?? 8}px 16px`,
              borderRadius: field.radius ?? 8,
              textDecoration: 'none',
              width: field.fullWidth ? '100%' : undefined,
              boxSizing: 'border-box',
            }}
          >
            {btnText}
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
            </svg>
          </LinkComponent>
        </div>
      )
    }

    return null
  }

  // ── Content block ──────────────────────────────────────────────────────
  const contentBlock = (
    <div style={{ padding: isSide ? `${padding}px` : `0 ${padding}px ${padding}px`, flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {fields.map(renderField)}
    </div>
  )

  // ── Card wrapper ───────────────────────────────────────────────────────
  const wrapperStyle = {
    background: rc(card.bg, '#fff'),
    borderRadius: card.radius ?? 16,
    border: (card.borderWidth ?? 0) > 0 ? `${card.borderWidth}px solid ${rc(card.borderColor, '#e5e7eb')}` : 'none',
    boxShadow: card.shadow ?? '0 4px 24px rgba(0,0,0,0.10)',
    overflow: 'hidden',
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    width: '100%',
  }

  // Side layout (left / right)
  if (isSide) return (
    <div style={{ ...wrapperStyle, display: 'flex', flexDirection: imgPos === 'right' ? 'row-reverse' : 'row', alignItems: 'flex-start' }}>
      <div style={{ padding, flexShrink: 0 }}>{photo}</div>
      {contentBlock}
    </div>
  )

  // Top-center layout
  const hasHeaderBg = card.headerBg && card.headerBg !== 'transparent'
  return (
    <div style={{ ...wrapperStyle }}>
      {hasHeaderBg && (
        <div style={{ height: imgH / 2 + 16, background: rc(card.headerBg) }} />
      )}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: hasHeaderBg ? -(imgH / 2) : padding, marginBottom: 8, paddingLeft: padding, paddingRight: padding }}>
        {agent.slug
          ? <LinkComponent href={`/agents/${agent.slug}`} style={{ display: 'flex' }}>{photo}</LinkComponent>
          : photo}
      </div>
      {contentBlock}
    </div>
  )
}

export default AgentCard